import { Component, OnInit, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ToolSearchParams } from 'src/app/shared/models/toolSearchParams';
import { Subject, Observable, of } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError, filter, map } from 'rxjs/operators';
import { ToolsService } from 'src/app/service/tools/tools.service';
import { LocalstorageService } from 'src/app/service/shared/localstorage/localstorage.service';
@Component({
  selector: 'app-job-search-box',
  templateUrl: './job-search-box.component.html',
  styleUrls: ['./job-search-box.component.scss'],
})
export class JobSearchComponent implements OnInit {
  searchParams: ToolSearchParams = {
    page: 1,
    limit: 50,
    embed: 'potentialJobDetail',
    attributes: 'id,jobNumber,name',
    order: 'jobNumber,DESC',
  };
  jobs;
  pagination;
  jobsBuffer = [];
  jobsBuffer$: Observable<any>;
  selectedJobs = [];
  input$ = new Subject<string>();
  loading = false;
  @Input() dropdownType;
  @Output() filter: EventEmitter<Array<Number>> = new EventEmitter<Array<Number>>();
  @ViewChild('SelectId') public select;

  constructor(
    private toolsService: ToolsService,
    private localStorageService: LocalstorageService,
  ) {}

  changeFn() {
    this.resetJobs();
    this.filter.emit(this.selectedJobs);
  }

  trackByFn(item) {
    return item.id;
  }

  ngOnInit(): void {
    this.getJobs();
  }

  ngOnChanges(changes) {}

  getJobs() {
    let toolFilter = JSON.parse(this.localStorageService.getItem('toolFilter'));
    this.selectedJobs = toolFilter && toolFilter['scope[job]'] ? toolFilter['scope[job]'].split(',') : [];
    this.toolsService.list['jobs'](this.searchParams).subscribe(res => {
      this.jobs = res.data;
      this.pagination = res.pagination;
      this.searchProd();
    });
  }

  resetJobs() {
    if (!this.selectedJobs.length) {
      delete this.searchParams.search;
      this.getJobs();
    }
  }

  fetchMore() {
    this.loading = true;
    let searchParams = this.searchParams;
    searchParams.page = this.pagination?.currentPage ? this.pagination.currentPage + 1 : 1;
    this.toolsService.list['jobs'](searchParams).subscribe(res => {
      this.loading = false;
      this.jobs = this.jobs.concat(res.data);
      this.searchParams.page = 1;
      this.pagination = res.pagination;
      this.jobsBuffer = this.jobsBuffer.concat(res.data);
      this.jobsBuffer$ = of(this.jobsBuffer);
    });
  }

  clearFilter() {
    this.selectedJobs = [];
    this.resetJobs();
  }

  searchProd(event = null) {
    if (event) this.searchParams = { ...this.searchParams, search: event.term };
    this.jobsBuffer = this.jobs.slice(0, 50);
    this.jobsBuffer$ = of(this.jobsBuffer);
    this.input$
      .pipe(
        debounceTime(200),
        distinctUntilChanged(),
        switchMap(term => this.toolsService.list['jobs'](this.searchParams)),
      )
      .subscribe(res => {
        this.pagination = res.pagination;
        this.jobsBuffer = res.data;
        this.jobsBuffer$ = of(this.jobsBuffer);
      });
  }

  scrollToEnd() {
    this.fetchMore();
  }

  openDropdown(event) {}

  closeDropdown(event) {
    this.resetJobs();
  }
}
